import React from "react";
import ReactDOM from "react-dom/client";
import App from "./core/App.jsx";

import "./styles/_styles.scss";

/**
 * React Application Entry Point
 *
 * Initializes the React application and mounts it to the DOM.
 * - Wraps the entire app in React.StrictMode for development warnings
 * - Imports global styles
 * - Mounts the root App component to the element with id="root"
 */
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
